import api from './api';
import type { ApiToken, CreateApiTokenData, CreateApiTokenResponse } from '../types/apiToken';

export const apiTokensService = {
  async listApiTokens(): Promise<ApiToken[]> {
    const response = await api.get<{ data: ApiToken[] }>('/api/api-tokens');
    return response.data.data;
  },

  async createApiToken(data: CreateApiTokenData): Promise<CreateApiTokenResponse> {
    const response = await api.post<CreateApiTokenResponse>('/api/api-tokens', data);
    return response.data;
  },

  async revokeApiToken(id: number): Promise<void> {
    await api.delete(`/api/api-tokens/${id}`);
  },
};
